import globalScript from "./js/globalScript.js";
class fvScript extends globalScript {
    constructor(system){
        super(system)
    }
    getFvObject(name){
        return this[name];
    }
    addFvObject(name){
        this[name] = this.system.manager[name];
    }
    addFvObjectEx(name,obj){
        this[name] = obj;
    }
    deleteFvObject(name){
        delete this[name];
    }
    /*
        参数：script 可执行的字符串或可执行函数
        参数：param 函数参数
        说明：script参数为字符串 param 格式为{paramName:"paramName"，value：param}
            其中 paramName 的值为构造function时的参数名称，，value 的值为执行时传递的参数
              script参数为可执行函数，param为执行时传递的参数数组，并以参数传递的顺序
              registerName: 因快速打开同一窗口 导致脚本没有执行结束， 赋值报错， 所以给与标记
    */
    async executionScript(script,param,registerName){
        if(script == "" || script == undefined) 
            return;
        if(param && (param.length >= 10||param.length <= 0)){
            console.warn("脚本执行函数参数个数不可大于 10 个");
            return;
        }
        if(param){
            if(typeof script == "string"){
                var params = [];
                var values = [];
                for(var i = 0;i < param.length;i++){
                    params.push(param[i].paramName);
                    params.push(param[i].value);
                }
                return await AsyncFunction(...params,script).call(this,...values);
            }else if(typeof script == "function"){
                return await script.call(this,...param);
            }else{
                console.warn("脚本类型错误：" + typeof script + " 只允许字符创脚本和可执行函数脚本");
                return;
            }
        }else{
            if(typeof script == "string"){
                if(registerName){
                    if(this[registerName]){
                        return await AsyncFunction(script).call(this);
                    }
                }else{
                    return await AsyncFunction(script).call(this);
                }
            }else if(typeof script == "function"){
                return await script.call(this);
            }else{
                console.warn("脚本类型错误：" + typeof script + " 只允许字符创脚本和可执行函数脚本");
                return;
            }
        }
    }  
}

export default fvScript;


// WEBPACK FOOTER //
// ./src/js/script/fvScript.js